/*
 * Created by alex@hackerbay.com on 5.2.2019
 * Copyright Singularity Technologies GmbH (c) 2019. All rights reserved
 */

import {PackageTrackingStatus} from "./packageTrackingStatus";

function hardwareWasShipped(orderStatus){
    return orderStatus && orderStatus.available === true
}

function hardwareWasDelivered(orderStatus){
    return orderStatus && orderStatus.tracking && orderStatus.tracking.status === PackageTrackingStatus.DELIVERED
}

export {hardwareWasShipped, hardwareWasDelivered}